// import React, { useState, useEffect } from 'react'
// import Api from '../Services/ApiCall';
// import Base from '../Base';

// export default function AgentDashboard() {
//     const [commissiondata, setCommissiondata] = useState([]);
//     const [cmmissionDatedata, setCommissionDatedata] = useState([]);
//     const [walletAmount, setWalletAmount] = useState("Loading...");
//     useEffect(() => {
//         bindCommision();
//         bindDateCommision();
//         GetWallet();
//     }, []);
//     async function bindDateCommision() {
//         var Id = sessionStorage.getItem("MUserID");
//         const currentDate = new Date().toISOString();
//         var d = new Date;
//         let month = d.getMonth() + 1;
//         if (month < 10) {
//             month = '0' + month;
//         }
//         let second = d.getSeconds();
//         if (second < 10) {
//             second = '0' + second;
//         }
//         var Hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
//         var date = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
//         var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
//         let curdate = d.getFullYear() + '-' + month + '-' + date + 'T' + Hour + ":"
//             + minute + ":" + second + ".965Z";
//         const url = `/Dashboard/BindAgentCommissionDate?Id=${Id}&date=${curdate}`;
//         let _response1 = await Api.BindDropdown(url)
//         setCommissionDatedata(_response1)
//     }
//     async function bindCommision() {
//         var Id = sessionStorage.getItem("MUserID")
//         var url = "/Dashboard/BindAgentCommission?Id=" + Id;
//         let _response1 = await Api.BindDropdown(url)
//         setCommissiondata(_response1)
//     }
//     async function GetWallet() {
//         var Id = sessionStorage.getItem("MUserID")
//         var Param = { Mstuserregid: Id}
//         var url = "/UserReg/GetUserRegtable1";
//         let _response = await Api.BindGrid(Param, url)
//         setWalletAmount(_response[0].Recharge_amount)
//     }
//     return (
//         <div>
//             <Base />
//             <div id="main" class="main">
//                 <h1>Agent Dashboard</h1>
//                 <div></div>
//                 <div className='row'>
//                     <div className="col-xl-4">
//                         <div className="card">
//                             <div className="card-body profile-card pt-4 d-flex flex-column align-items-center">
//                                 <h2>Total Wallet </h2>
//                                 <h3>{walletAmount}</h3>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }


// AgentDashboard.js
import React, { useState, useEffect } from 'react';
import Api from '../Services/ApiCall';
import { FaUserTie, FaUsers, FaBriefcase, FaWallet, FaCrown } from 'react-icons/fa';

const AgentDashboard = () => {
    const [walletAmount, setWalletAmount] = useState("Loading...");
    const [plantype, setPlantype] = useState("Loading...");
    useEffect(() => {
        GetWallet();
    }, []);
    async function GetWallet() {
        var Id = sessionStorage.getItem("MUserID")
        var Param = { Mstuserregid: Id }
        var url = "/UserReg/GetUserRegtable1";
        let _response = await Api.BindGrid(Param, url)
        setWalletAmount(_response[0].Recharge_amount)
        // setPlanendDate(_response[0].PlanendDate)
        setPlantype(_response[0].Plantype1)
    }
    const cards = [
        {
            title: 'Employers Created',
            value: 5,
            icon: <FaUserTie />,
            btn: 'View Employers',
        },
        {
            title: 'Jobseekers Created',
            value: 8,
            icon: <FaUsers />,
            btn: 'View Jobseekers',
        },
        {
            title: 'Jobs Posted',
            value: 3,
            icon: <FaBriefcase />,
            btn: 'View Jobs',
        },
        {
            title: 'Wallet Balance',
            value: `$${walletAmount}`,
            icon: <FaWallet />,
            btn: 'Top Up Wallet',
        },
        {
            title: 'Subscription Plan',
            value: plantype,
            icon: <FaCrown />,
            btn: 'Manage Plan',
            // endDate: 'Ends on: 30 June 2025',
        },
    ];

    return (
        <div>
            <div id="main" class="main">
                <div className="row g-4 justify-content-center">
                    {cards.map((card, i) => (
                        <div className="col-md-4" key={i}>
                            <div className="dashboard-card">
                                <div className="icon-box">{card.icon}</div>
                                <h5>{card.title}</h5>
                                <p className="value">{card.value}</p>
                                {card.endDate && <p className="subtext">{card.endDate}</p>}
                                <button className="action-btn">{card.btn}</button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AgentDashboard;
